/**
 * Created by vlad on 15.11.18.
 */

cleverapps.overrideStyles(cleverapps.styles.MuffinComponentView, {
    smile: true,
    hurtEffect: "match3.muffin.hurt",
    boomColor: new cc.Color(156, 51, 0, 255)
});